exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  outline: none;\n}\nbody {\n  margin: 0;\n  overflow: hidden;\n}\n.hidden {\n  display: none !important;\n}\n\n\n.highlighted {\n  color: yellow;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/sergeisidorov/Projects/streamViewer/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/sergeisidorov/Projects/streamViewer/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/sergeisidorov/Projects/streamViewer/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles